"use strict";

function _typeof2(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof2 = function _typeof2(obj) { return typeof obj; }; } else { _typeof2 = function _typeof2(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof2(obj); }

var _typeof = "function" == typeof Symbol && "symbol" == _typeof2(Symbol.iterator) ? function (o) {
  return _typeof2(o);
} : function (o) {
  return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : _typeof2(o);
};

!function () {
  function o(e, t) {
    if (!o.installed) {
      if (o.installed = !0, !t) return void console.error("You have to install axios");
      e.axios = t, Object.defineProperties(e.prototype, {
        axios: {
          get: function get() {
            return t;
          }
        },
        $http: {
          get: function get() {
            return t;
          }
        }
      });
    }
  }

  "object" == ("undefined" == typeof exports ? "undefined" : _typeof(exports)) ? module.exports = o : "function" == typeof define && define.amd ? define([], function () {
    return o;
  }) : window.Vue && window.axios && Vue.use(o, window.axios);
}();